import React, { useEffect, useState } from "react";
import s from "../Profile.module.css";
import { useAuth } from "../context/AuthContext";
import { useAppTranslation } from "./TranslationContext";
import { Link } from "react-router-dom";

const CourseCard = ({ course, index }) => (
  <Link className={s.courseLink} to={"/course/" + course.id}>
    <div className={s.courseCard} style={{ animationDelay: `${index * 0.06}s` }}>
      <span className={s.courseCardNum}>
        {String(index + 1).padStart(2, '0')}
      </span>
      <img
        src={course.img}
        alt=""
        className={s.courseCardImg}
        onError={(e) => { e.target.onerror = null; e.target.src = "/images/default.png"; }}
      />
      <p className={s.courseCardTitle}>{course.title}</p>
      <p className={s.courseCardInfo}>{course.info}</p>
    </div>
  </Link>
);

export const Profile = () => {
  const [userData, setUserData]                   = useState([]);
  const [loadingUser, setLoadingUser]             = useState(true);
  const [errorUser, setErrorUser]                 = useState(null);
  const [allCourses, setAllCourses]               = useState([]);
  const [myCourses, setMyCourses]                 = useState([]);
  const [recommendedCourses, setRecommendedCourses] = useState([]);

  const { user, handleLang } = useAuth();
  const { t } = useAppTranslation();

  /* user-kurs */
  useEffect(() => {
    if (!user?.id) return;
    fetch(`https://api.aiassessment.uz/api/user-kurs/?user=${user.id}`)
      .then(r => { if (!r.ok) throw new Error("Ошибка сети: " + r.status); return r.json(); })
      .then(json => { setUserData(json || []); setLoadingUser(false); })
      .catch(err => { setErrorUser(err.message); setLoadingUser(false); });
  }, [user?.id]);

  /* all courses */
  useEffect(() => {
    if (loadingUser) return;
    fetch("https://api.aiassessment.uz/api/kurslar/")
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(all => setAllCourses(Array.isArray(all) ? all : []))
      .catch(() => setAllCourses([]));
  }, [loadingUser]);

  /* split my / recommended */
  useEffect(() => {
    const myIds = new Set(userData.map(k => k.kurs));
    setMyCourses(allCourses.filter(c => myIds.has(c.id)));
    setRecommendedCourses(
      [...allCourses.filter(c => !myIds.has(c.id))]
        .sort(() => Math.random() - 0.5)
        .slice(0, 6)
    );
  }, [allCourses, userData]);

  if (loadingUser) return <div className={s.loadingPage}>Yuklanmoqda...</div>;
  if (errorUser)   return <div className={s.loadingPage} style={{ color: '#ff4444' }}>Xatolik: {errorUser}</div>;

  const toCard = (course, i) => ({
    id:    course.id,
    title: handleLang(course.nomi_uz, course.nomi_ru, course.nomi_en),
    info:  handleLang(course.description_uz, course.description_ru, course.description_en),
    img:   course.img_uz,
  });

  return (
    <div className={s.page}>

      {/* ── HERO ── */}
      <div className={s.hero}>
        <div className={s.heroLeft}>
          <span className={s.heroBadge}>{t('hello')}</span>
          <h1 className={s.heroTitle}>
            {t('hello')},&nbsp;<span>{user.username}</span>!
          </h1>
          <p className={s.heroSub}>{t('profileSub')}</p>
          <Link to="/more" className={s.heroBtn}>
            <span className={s.heroBtnText}>{t('profileCustom')}</span>
          </Link>
        </div>
        <div className={s.heroImgWrap}>
          <img src="/images/userSite.png" alt="" className={s.heroImg} />
        </div>
      </div>

      {/* ── MY COURSES ── */}
      {myCourses.length > 0 && (
        <div className={s.section}>
          <span className={s.sectionLabel}>{t('myCourses')}</span>
          <h2 className={s.sectionTitle}>{t('myCourses')}</h2>
          <div className={s.grid}>
            {myCourses.map((course, i) => (
              <CourseCard key={course.id} course={toCard(course, i)} index={i} />
            ))}
          </div>
        </div>
      )}

      {/* ── RECOMMENDED ── */}
      {recommendedCourses.length > 0 && (
        <div className={s.section}>
          <span className={s.sectionLabel}>{t('popCourses')}</span>
          <h2 className={s.sectionTitle}>{t('popCourses')}</h2>
          <div className={s.grid}>
            {recommendedCourses.map((course, i) => (
              <CourseCard key={course.id} course={toCard(course, i)} index={i} />
            ))}
          </div>
        </div>
      )}

    </div>
  );
};
